import request from '@/utils/request'

export function getEnterpriseList(params) {
  return request({
    url: '/auth/v1/enterprise/statistic/list',
    method: 'get',
    params
  })
}
